import { prepareParams } from "../../utils";

export const auditApi = (api) =>
  api.injectEndpoints({
    endpoints: (build) => ({
      getAuditIndex: build.query({
        query: (params) => {
          return `v1/audit?${prepareParams(params)}`;
        },
      }),
    }),
  });
